import axios from "axios";

// Set the backend API base URL
const backendBaseUrl = "https://pettt-307b72dedaba.herokuapp.com";

export const loginUser = (user) =>
  axios.post(`${backendBaseUrl}/loginUser`, user);

export const registerUser = (user) =>
  axios.post(`${backendBaseUrl}/saveUser`, user);

export const saveOrder = (orderDetail) =>
  axios.post(`${backendBaseUrl}/saveOrder`, orderDetail);

export const getAllOrdersForUser = (id) =>
  axios.get(`${backendBaseUrl}/getOrders/${id}`);

export const saveAppointment = (appointmentDetail) =>
  axios.post(`${backendBaseUrl}/saveAppointment`, appointmentDetail);

export const getAllAppointments = (id) =>
  axios.get(`${backendBaseUrl}/getAppointments/${id}`);

export const saveCart = (cart) =>
  axios.post(`${backendBaseUrl}/saveCart`, cart);

export const getCart = (userId) =>
  axios.get(`${backendBaseUrl}/getCart/${userId}`);

export const updatePassword = (user) =>
  axios.post(`${backendBaseUrl}/updatePassword`, user);

export const sendOtp = (email) =>
  axios.get(`${backendBaseUrl}/sendOtp/${email}`);
